import { updateObject } from "../../../../shared";
import {
  globalConstants,
  PAGINATION_DEFAULTS,
  PAGINATION_SENTINELS,
  activityLogsConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;
const { FETCH_ACTIVITY_LOGS } = activityLogsConstants;

// Keep the total unknown until the first activity log response arrives.
const initialState = {
  collectiveData: {},
  activityLogsData: [],
  activityLogsPaginationData: {
    ...PAGINATION_DEFAULTS,
    totalElements: PAGINATION_SENTINELS.UNKNOWN_TOTAL_ELEMENTS,
  },
};

//Manipulating the state of activity logs based on actions and returning the state
export const activityLogsReducer = (state = initialState, action) => {
  if (action.type === FETCH_ACTIVITY_LOGS + SUCCESS) {
    return updateObject(state, {
      activityLogsData: action.data.pageData,
      collectiveData: action.data.componentData,
      activityLogsPaginationData: action.data.page,
    });
  } else {
    return state;
  }
};
